import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { Provider } from "react-redux";

import configureStore from "./configure-store";

import EventRegisterForm from "./containers/EventRegisterForm";

export default (props) => {
  const store = configureStore(props);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Route path="/events/:event_id" render={() => <EventRegisterForm {...props} />} />
      </BrowserRouter>
    </Provider>
  );
};
